var _a;
import { generatePromises } from "../generators/generator.promises";
import { GENERATOR_PARAMS } from "./propertyCost.constants";
export var getDetail = (_a = generatePromises(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, getInfiniteLoad = _a.getInfiniteLoad, create = _a.create, update = _a.update, remove = _a.remove;
